export default __webpack_public_path__ + "static/pe-1b49a2d877b944128ec2b82281e690f9.svg";